export class QueueOfFunctions {
  ready: boolean;
  queue: (() => void)[];

  constructor() {
    this.queue = [];
    this.ready = false;
  }

  runWhenReady(fn: () => void) {
    if (this.ready) {
      fn();
      return;
    }

    this.queue.push(fn);
  }

  setAsReady = () => {
    if (this.ready) {
      return;
    }

    this.ready = true;
    this.queue.forEach(fn => {
      fn();
    });

    this.queue = [];
  };
}

export const analyticsSetupQueue = new QueueOfFunctions();
